"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregatorPlugin = void 0;
const aggregator_module_1 = require("./aggregator.module");
const aggregatorPlugin = () => {
    return {
        install(ctx) {
            ctx.aggregator = new aggregator_module_1.AggregatorModule(ctx);
        },
    };
};
exports.aggregatorPlugin = aggregatorPlugin;
